export default __webpack_public_path__ + "static/media/eng. sis electric.9b0b23ef.pdf";